<template>
	<report-page
		:start-date="true"
		:end-date="true"
		get-url="/bo/report/claims/claimquestionresponses"
		title="Claim Question Responses"
		subtitle="An export of claims and the responses to the various dynamic claim questions."
		export-filename="claim_responses"
	/>
</template>

<script>
export default {
	name: 'ClaimQuestionResponsesReport',
};
</script>
